import React from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const MobileMenu = ({ open, links }) => {
  if (!open) return null;
  return (
    <div className="lg:hidden border-t border-razmek bg-white">
      <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-col gap-5">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`${l.id}-mobile`}
            className="font-sans text-sm tracking-[0.14em] uppercase text-razmek-dark"
          >
            {l.label}
          </Link>
        ))}
        <Link to="/precalificacion">
          <Button className="w-full bg-razmek-blue hover:bg-razmek-dark text-white rounded-none font-sans tracking-[0.14em] uppercase text-[11px] py-5">
            Agendar asesoría
          </Button>
        </Link>
      </div>
    </div>
  );
};

export const MobileMenuToggle = ({ open, onToggle, testId }) => (
  <button
    data-testid={testId}
    className="lg:hidden p-2 text-razmek-dark"
    onClick={onToggle}
    aria-label="menu"
  >
    {open ? <X size={22} /> : <Menu size={22} />}
  </button>
);

export default MobileMenu;
